import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2bd3e3a9"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id", "onMouseenter"];
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ROAS", -1));
const _hoisted_4 = {
  class: "value"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = {
  class: "details"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "Revenue", -1));
const _hoisted_9 = {
  class: "value"
};
const _hoisted_10 = {
  class: "text"
};
const _hoisted_11 = {
  class: "content"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "Spend", -1));
const _hoisted_13 = {
  class: "value"
};
const _hoisted_14 = {
  class: "text"
};
const _hoisted_15 = {
  class: "content"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "TACOS", -1));
const _hoisted_17 = {
  class: "value"
};
const _hoisted_18 = {
  class: "period-string"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Line = _resolveComponent("Line");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Line, {
    ref: `${$options.uid}_roas_chart`,
    data: $options.processedData,
    options: $options.options
  }, null, 8, ["data", "options"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pointPositions, (point, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      id: `${$options.uid}_node_${index}`,
      class: _normalizeClass(["generated-point", $options.isHovering(index)]),
      style: _normalizeStyle($options.pointCustomStyle(point)),
      onMouseenter: $event => $options.onHovering(index),
      onMouseleave: _cache[0] || (_cache[0] = (...args) => $options.onLeaving && $options.onLeaving(...args))
    }, [_createVNode(_component_app_popover, {
      target: `${$options.uid}_node_${index}`,
      customClass: "tooltip-hover",
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(`${$props.values?.[index]?.ROAS?.toFixed(2) ?? "-"}`), 1), _createElementVNode("div", {
        class: "text",
        style: _normalizeStyle({
          color: $props.values[index]?.roas_evol_vs_previous_period == 0 || $props.values[index]?.roas_evol_vs_previous_period == null ? this.grayColor : $props.values[index]?.roas_evol_vs_previous_period > 0 ? this.greenColor : this.redColor
        })
      }, _toDisplayString($props.values[index]?.roas_evol_vs_previous_period > 0 ? `+${$props.values?.[index]?.roas_evol_vs_previous_period?.toFixed(2) ?? "-"}` : `${$props.values?.[index]?.roas_evol_vs_previous_period?.toFixed(2) ?? "-"}`), 5)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_currency_value, {
        value: $props.values?.[index]?.revenue,
        precision: "2"
      }, null, 8, ["value"])]), _createVNode(_component_percentage_value, {
        class: "text",
        value: $props.values[index]?.revenue_evol_vs_previous_period,
        color: $props.values[index]?.revenue_evol_vs_previous_period == 0 || $props.values[index]?.revenue_evol_vs_previous_period == null ? this.grayColor : $props.values[index]?.revenue_evol_vs_previous_period > 0 ? this.greenColor : this.redColor,
        charCount: 5,
        precision: Math.abs($props.values[index]?.revenue_evol_vs_previous_period) >= 0.001 && Math.abs($props.values[index]?.revenue_evol_vs_previous_period) <= 0.009 ? 1 : 0,
        showSign: ""
      }, null, 8, ["value", "color", "precision"])])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_currency_value, {
        value: $props.values?.[index]?.spend,
        precision: "2"
      }, null, 8, ["value"])]), _createVNode(_component_percentage_value, {
        class: "text",
        value: $props.values[index]?.spend_evol_vs_previous_period,
        color: $props.values[index]?.spend_evol_vs_previous_period == 0 || $props.values[index]?.spend_evol_vs_previous_period == null ? this.grayColor : $props.values[index]?.spend_evol_vs_previous_period > 0 ? this.greenColor : this.redColor,
        charCount: 5,
        precision: Math.abs($props.values[index]?.spend_evol_vs_previous_period) >= 0.001 && Math.abs($props.values[index]?.spend_evol_vs_previous_period) <= 0.009 ? 1 : 0,
        showSign: ""
      }, null, 8, ["value", "color", "precision"])])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createVNode(_component_percentage_value, {
        class: "text",
        value: $props.values[index]?.TACOS,
        color: "#4D4D4D"
      }, null, 8, ["value"]), _createVNode(_component_percentage_value, {
        class: "text",
        value: $props.values[index]?.tacos_evol_vs_previous_period,
        color: $props.values[index]?.tacos_evol_vs_previous_period == 0 || $props.values[index]?.tacos_evol_vs_previous_period == null ? this.grayColor : $props.values[index]?.tacos_evol_vs_previous_period > 0 ? this.greenColor : this.redColor,
        charCount: 5,
        precision: Math.abs($props.values[index]?.tacos_evol_vs_previous_period) >= 0.001 && Math.abs($props.values[index]?.tacos_evol_vs_previous_period) <= 0.009 ? 1 : 0,
        showSign: "",
        pp: ""
      }, null, 8, ["value", "color", "precision"])])])]), _createElementVNode("div", _hoisted_18, _toDisplayString($props.values?.[index]?.label), 1)]),
      _: 2
    }, 1032, ["target"])], 46, _hoisted_1);
  }), 128))], 64);
}